import React, { useEffect, useState } from 'react';
import { Translator } from './components/Translator';
import { useLocation } from 'react-router-dom';
import { Authenticator } from './components/Authenticator/Authenticator';
import 'cdux_common/dist/cdux_common.css';

export default function App() {
    const location = useLocation();

    const defaultbackgroundColor = "34182D"
    const [projectInfo, setProjectInfo] = useState(undefined);
    const [backgroundColor, setBackgroundColor] = useState(undefined);


    useEffect(() => {
        let version = `${process.env.REACT_APP_VERSION}`;
        console.log(`-- version ${version} --`);
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setProjectInfo({
            id: params.get('id'),
            readonly: params.get('readonly')
        });

        const color = params.get('background')?.toLowerCase();
        const trimmedColor = color ? color.substring(0, 6) : '';
        if (trimmedColor && trimmedColor.length === 6 && trimmedColor.match(/[a-f0-9]{6}/)) {
            document.body.style.backgroundColor = `#${trimmedColor}`;
            setBackgroundColor(trimmedColor);
        } else {
            document.body.style.backgroundColor = `#${defaultbackgroundColor}`;
            setBackgroundColor(defaultbackgroundColor);
        }

    }, [location]);

    return (
        <div className="App">
            <Translator>
                <Authenticator projectInfo={projectInfo} primaryColor={backgroundColor} />
            </Translator>
        </div>
    );
}
